import React, { useEffect, useState } from 'react';
import { View, TextInput, Pressable } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import formatAssetName, { formatAddress } from '../../utils/formatAssetName';

import { Text, Hint } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

import { AUTOCOMPLETE } from './queries';
import Result from './Result';

export const Container = styled(View)`
  flex-direction: row;
  background-color: white;
  align-self: left;
  align-items: center;
  height: 32px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 0px;
  margin-right: 40px;
  margin-bottom: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  min-width: 100%;
  position: relative;
`;

export const Input = styled(TextInput)`
  outline-width: 0px;
  outline-color: white;
  margin-left: 12px;
  width: 90%;
  positon: absolute;
  z-index: 1;
`;

export const Results = styled(View)`
  position: absolute;
  top: 30px;
  left: 5px;
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  padding-top: 5px;
  width: 200%;
  z-index: 99999 !important;
`;

const Autocomplete = ({ resource, label, placeHolder, setValue, name,
    setResource, defaultValue, zIndex, hint
}) => {
  const [term, setTerm] = useState('');
  const [resources, setResources] = useState([]);
  const [clickedResult, setClickedResult] = useState(defaultValue);
  const [getResults, { data }] = useLazyQuery(AUTOCOMPLETE);

  useEffect(() => {
    if (term && term.length >= 1) {
      getResults({ variables: { resource: resource, term: term,
        name: name
      }});
      if(resource === 'InputOption') {
        setValue(name, term);
      }
    }
  }, [term]);

  useEffect(() => {
    if(data) {
      let resources = '';
      if(resource === 'InputOption' && name === 'make') {
        resources = 'makes'
      }else if( resource === 'InputOption' && name === 'model') {
        resources = 'models'
      }else {
        resources = `${resource.toLowerCase()}s`
      }


      setResources(data.autocomplete[0][resources]);
    }
  }, [data])

  useEffect(() => {
    if(defaultValue !== '') {
      setClickedResult(defaultValue);
    }
  }, [defaultValue])

  const getResultLabel = (resultData) => {
    switch(resultData?.__typename) {
      case 'Asset':
        return `${resultData.vin} | ${resultData.stockNumber} | ${resultData.seller?.name} | ${resultData.name}`
        break;
      case 'Commission':
      case 'Seller':
      case 'Vendor':
        return resultData.name;
        break;
      case 'Location':
        return formatAddress(resultData);
      case 'InputOption':
        return resultData.label;
        break;
      case 'User':
        return resultData.fullName;
      default:
        break;
    }
  }

  return (
    <View style={{ zIndex: (zIndex || 9000) }}>
      <Text>{label}:</Text>
      {hint && <Hint>{hint}</Hint>}
      <Container>
        {term || clickedResult ? (
          <Pressable onPress={() => {
            setTerm('')
            setClickedResult();
          }}>
            <FontAwesomeIcon
              icon={faXmark}
              color={colors.disabled}
            />
          </Pressable>
        ) : (
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            color={colors.disabled}
          />
        )}
        <Input
          placeholder={placeHolder}
          placeholderTextColor="#202020"
          value={getResultLabel(clickedResult) || term}
          onChange={e => {
            setTerm(e.target.value);
          }}
        />
        {resources && term.length >= 1 && resources.length > 0 && (
          <Results style={{zIndex: 99990}}>
            {resources?.map(result => (
              <Result
                key={`${result.__typename}-${result.id}`}
                result={result}
                setTerm={setTerm}
                setValue={setValue}
                name={name}
                setClickedResult={setClickedResult}
                resourceType={result.__typename?.toLowerCase()}
                setResource={setResource}
              />
            ))}
          </Results>
        )}
      </Container>
    </View>
  );
};

export default Autocomplete;
